import { TextUtils } from "common/utils/textUtils";
import { CategoryChipRoot } from "./CategoryChip.styles";

export interface CategoryChipProps {
    category: string;
    selected?: boolean;
    handleClick?: (category: string) => void;
}

function CategoryChip({ category, selected = false, handleClick }: CategoryChipProps) {
    return (
        <CategoryChipRoot selected={selected} onClick={() => handleClick ? handleClick(category) : null} >
            {TextUtils.capitalizeText(category)}
        </CategoryChipRoot>
    )
}

export default CategoryChip;